export default function LogoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.488 1.90545C11.2148 1.70635 10.898 1.57556 10.564 1.52402C10.2299 1.47248 9.88841 1.50169 9.56797 1.6092L5.64922 2.91045C5.21967 3.05324 4.84622 3.32813 4.58222 3.69584C4.31822 4.06355 4.17717 4.50529 4.17922 4.95795V19.0429C4.17718 19.4956 4.31823 19.9373 4.58223 20.305C4.84623 20.6728 5.21967 20.9476 5.64922 21.0905L9.56797 22.3917C9.89079 22.4976 10.2342 22.5254 10.5698 22.4725C10.9054 22.4197 11.2237 22.2879 11.4984 22.0879C11.7731 21.888 11.9963 21.6256 12.1496 21.3224C12.303 21.0192 12.3821 20.684 12.3805 20.3442V3.6567C12.3829 3.31465 12.303 2.97703 12.1477 2.67226C11.9924 2.3675 11.7661 2.10452 11.488 1.90545ZM13.1305 12.563V20.3442C13.1306 20.4696 13.123 20.5948 13.108 20.7192H17.758C18.3047 20.7183 18.8287 20.5006 19.2153 20.1141C19.6019 19.7275 19.8195 19.2034 19.8205 18.6567V5.34422C19.8195 4.7975 19.6019 4.27346 19.2153 3.88687C18.8287 3.50028 18.3047 3.28268 17.758 3.28172H13.108C13.123 3.40615 13.1306 3.53138 13.1305 3.65672V11.438H16.4717L14.9267 9.88172L15.7292 9.08672L18.223 11.603C18.3275 11.7089 18.3861 11.8517 18.3861 12.0005C18.3861 12.1493 18.3275 12.2921 18.223 12.398L15.7292 14.9142L14.9267 14.1192L16.4717 12.563H13.1305Z"
        fill="#E24B4B"
      />
    </svg>
  );
}
